// extracted by mini-css-extract-plugin
export default {"aboutUsPageContainer":"AboutUsPage_aboutUsPageContainer__q6+su","grid":"AboutUsPage_grid__LOs1g","imgContainer":"AboutUsPage_imgContainer__G6qW0","item":"AboutUsPage_item__ba9wW"};